/**
 * @generated SignedSource<<7d1d41b82adae37be12ed033b29e2797>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EventMeetingFormFields_OrganizationFragment$data = {
  readonly id: string;
  readonly meetingProviders: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"OrganizationZoomConnectionListItemFragment">;
      };
    }>;
  } | null;
  readonly " $fragmentType": "EventMeetingFormFields_OrganizationFragment";
};
export type EventMeetingFormFields_OrganizationFragment$key = {
  readonly " $data"?: EventMeetingFormFields_OrganizationFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventMeetingFormFields_OrganizationFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventMeetingFormFields_OrganizationFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "platform",
          "value": "zoom"
        }
      ],
      "concreteType": "MeetingProviderNodeConnection",
      "kind": "LinkedField",
      "name": "meetingProviders",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingProviderNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MeetingProvider",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "OrganizationZoomConnectionListItemFragment"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "meetingProviders(platform:\"zoom\")"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
})();

(node as any).hash = "f503b55ec40f775405fa7fabd4fc0647";

export default node;
